import SignInSSO from "../pages/signin/signin.page";
import SignUp from '../pages/signup/signup.page';
import Dashboard from '../pages/dashboard/dashboard.page';

interface Route {
    key: string,
    title: string,
    path: string,
    enabled: boolean,
    component: any
}

export const routes: Array<Route> = [
    {
        key: "home",
        title: "Dashboard",
        path: "/",
        enabled: true,
        component: Dashboard
    },
    {
        key: 'sign-up',
        title: 'Sign up',
        path: '/sign-up',
        enabled: true,
        component: SignUp
    },
    {
        key: 'sign-in',
        title: 'Sign in',
        path: '/sign-sso',
        enabled: true,
        component: SignInSSO
    },
    // {
    //     key: 'dashboard',
    //     title: 'Dashboard',
    //     path: '/dashboard',
    //     enabled: true,
    //     component: Dashboard
    // }
]